import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { EspelhoDeVendasHorizontalPageSuspense } from '@/features/espelho-de-vendas/shared/components/espelho-de-vendas-horizontal.suspense'

const EspelhoDeVendasPage = lazy(() =>
  import('@/features/espelho-de-vendas/brasil/pages/listagem-empreendimentos').then((module) => ({
    default: module.EspelhoDeVendasPage,
  })),
)

const EspelhoDeVendasEmpreendimentoPage = lazy(() =>
  import('@/features/espelho-de-vendas/brasil/pages/espelho-de-vendas-vertical').then((module) => ({
    default: module.EspelhoDeVendasEmpreendimentoPage,
  })),
)

const EspelhoDeVendasHorizontalPage = lazy(() =>
  import('@/features/espelho-de-vendas/brasil/pages/espelho-de-vendas-horizontal').then((module) => ({
    default: module.EspelhoDeVendasHorizontalPage,
  })),
)

export const brasilEspelhoDeVendasRoutes: RouteObject[] = [
  {
    path: 'espelho-de-vendas',
    children: [
      {
        index: true,
        element: <EspelhoDeVendasPage />,
      },
      {
        path: ':idExternoEmpreendimento',
        element: <EspelhoDeVendasEmpreendimentoPage />,
      },
      {
        path: 'horizontal/:idExternoEmpreendimento',
        element: (
          <EspelhoDeVendasHorizontalPageSuspense>
            <EspelhoDeVendasHorizontalPage />
          </EspelhoDeVendasHorizontalPageSuspense>
        ),
      },
    ],
  },
]
